/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A1Inputs */

const en_minifier_faq_a1 = /** @type {(inputs: Minifier_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between roughly 20 and 60 percent of raw bytes, depending on how deeply nested the document is and how short its values are. On a measured 40 record sample it was 41.7 percent. Over HTTP with gzip enabled the real saving drops to around 10 percent.`)
};

const ko_minifier_faq_a1 = /** @type {(inputs: Minifier_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서가 얼마나 깊게 중첩되었고 값이 얼마나 짧은지에 따라 대략 원본 바이트의 20에서 60퍼센트입니다. 실측한 40개 레코드 표본에서는 41.7퍼센트였습니다. gzip이 켜진 HTTP에서는 실제 절감이 10퍼센트 근처로 떨어집니다.`)
};

const ja_minifier_faq_a1 = /** @type {(inputs: Minifier_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書がどれだけ深くネストしているか、値がどれだけ短いかによって、おおよそ元のバイトの 20 から 60 パーセントです。実測した 40 件のサンプルでは 41.7 パーセントでした。gzip が有効な HTTP では実際の削減は 10 パーセント前後まで落ちます。`)
};

/**
* | output |
* | --- |
* | "Between roughly 20 and 60 percent of raw bytes, depending on how deeply nested the document is and how short its values are. On a measured 40 record sample i..." |
*
* @param {Minifier_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a1 = /** @type {((inputs?: Minifier_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a1(inputs)
	if (locale === "ko") return ko_minifier_faq_a1(inputs)
	return ja_minifier_faq_a1(inputs)
});